import { Button, Tooltip } from '@modusign/design-system';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { useExternalDocumentPermission } from '@app/features/externalDocument/hooks/useExternalDocumentPermission';
import pushDataLayer from '@app/libs/analytics/googleTagManager';

import { getUploadingSummary } from '../../state';

export default function UploadPageLinkButton() {
  const history = useHistory();

  const { createPermission } = useExternalDocumentPermission();
  const summary = useSelector(getUploadingSummary);
  const isUploadingDocuments = !!(summary.idle || summary.pending);

  let tooltipContent: ReactNode = null;

  if (!createPermission.isPermitted) {
    tooltipContent = createPermission.message;
  } else if (isUploadingDocuments) {
    tooltipContent = [
      '등록이 진행 중인 계약이 있습니다.',
      <br key="key-1" />,
      '모두 완료된 후 이용해 주세요.',
    ];
  } else if (summary.failed) {
    tooltipContent = [
      '등록에 실패한 계약이 있습니다.',
      <br key="key-1" />,
      '확인 후 이용해 주세요.',
    ];
  }

  return (
    <Tooltip content={tooltipContent} disabled={!tooltipContent} placement="bottom">
      <Button
        className="tagUploadExternalDocument"
        disabled={!!tooltipContent}
        height="36px"
        sx={{ flex: 'none' }}
        weight="light"
        whiteSpace="nowrap"
        onClick={() => {
          if (isUploadingDocuments) {
            return;
          }

          pushDataLayer({ event: 'clickCreateExternalDocument' });
          const url = '/external-documents/upload';
          history.push(url);
        }}
      >
        + 계약 등록
      </Button>
    </Tooltip>
  );
}
